import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBubbles = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.2,
			cy: 14.4,
			r: 3.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14.8,
			cy: 18,
			r: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15.2,
			cy: 8.8,
			r: 4.8
		})
	]
});
export default SvgBubbles;
